"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.OtcWebviewInteractionType=void 0;var i;(function(e){e.CloseClicked="CloseClicked",e.InfoClicked="InfoClicked"})(i||(exports.OtcWebviewInteractionType=i={}));
//# sourceMappingURL=OtcWebviewInteractionType.js.map
